import defaultTheme, { ThemeT } from './defaultTheme'

const theme: ThemeT = {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    '--logo-color': 'linear-gradient(135deg, var(--vanadyl-blue), var(--primary-blue))',
    '--main-hover-background-color': 'var(--chef-hat)',
    '--main-active-background-color': 'var(--light-violet)',
    '--main-selected-background-color': 'var(--primary-blue)',
  },
  fonts: {
    ...defaultTheme.fonts,
    fontFamilies: {
      ...defaultTheme.fonts.fontFamilies,
      '--main-font-family': 'var(--noto-sans)',
    },
  },
}

export default theme
